var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.74,8.54h-8.5A2.26,2.26,0,0,0,9,10.8v8.94A2.26,2.26,0,0,0,11.24,22h8.5A2.26,2.26,0,0,0,22,19.74V10.8A2.26,2.26,0,0,0,19.74,8.54Zm.17,11.2a.18.18,0,0,1-.17.18h-8.5a.18.18,0,0,1-.18-.18V10.8a.18.18,0,0,1,.18-.18h8.5a.18.18,0,0,1,.17.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09,13.2V4.26a.18.18,0,0,1,.17-.18h8.5a.18.18,0,0,1,.18.18V7.08H15V4.26A2.26,2.26,0,0,0,12.76,2H4.26A2.26,2.26,0,0,0,2,4.26V13.2a2.26,2.26,0,0,0,2.26,2.26H7.52V13.38H4.26A.18.18,0,0,1,4.09,13.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b6adf339ca0e68f58d1239ca9294f153.svg";
export { ForwardRef as ReactComponent };